import {
  DataTable,
  DataTableBrowserPagination,
  DataTableContainer,
  useDataTableController,
} from "@/shared/components/tables/data-table";
import { ColumnDef } from "@tanstack/react-table";
import t from "@/lang/lang";
import {
  Item,
  VisualAssessmentCatalog,
} from "@/services/backend/htz/inspection/types/visual-assessment-catalog";
import { DeleteVisualAssessmentCatalogItemDialog } from "@/services/backend/htz/inspection/components/delete-visual-assessment-catalog-item-dialog";
import { PutVisualAssessmentCatalogItemDialog } from "@/services/backend/htz/inspection/components/put-visual-assessment-catalog-item-dialog";
import { ComponentKindName } from "@/services/backend/htz/ahu/components/component-kind-name";
import { ResultDot } from "@/services/backend/htz/inspection/components/inspection-result";

export function VisualAssessmentCatalogItemsTable({
  catalog,
}: {
  catalog: VisualAssessmentCatalog;
}) {
  const table = useDataTableController(tableColumns, catalog.items);

  return (
    <DataTableContainer>
      <div className="border-b">
        <DataTable
          table={table}
          columns={tableColumns}
          className="border-none"
        />
      </div>
      <div className="px-4 pb-2">
        <DataTableBrowserPagination table={table} />
      </div>
    </DataTableContainer>
  );
}

const tableColumns: ColumnDef<Item>[] = [
  {
    header: t("Relevant für Arten von Komponenten"),
    cell: ({ row }) => (
      <div>
        {row.original.componentKinds.map((kindId, index) => (
          <span key={kindId}>
            <ComponentKindName id={kindId} />
            {index < row.original.componentKinds.length - 1 && ", "}
          </span>
        ))}
      </div>
    ),
  },
  {
    header: t("Mangel"),
    accessorKey: "deficiency",
    cell: ({ row }) => (
      <div className="max-w-[400px] truncate" title={row.original.deficiency}>
        {row.original.deficiency}
      </div>
    ),
  },
  {
    header: t("Empfehlung"),
    accessorKey: "recommendation",
    cell: ({ row }) => (
      <div
        className="max-w-[400px] truncate"
        title={row.original.recommendation}
      >
        {row.original.recommendation}
      </div>
    ),
  },
  {
    header: t("Beurteilung"),
    accessorKey: "result",
    cell: ({ row }) => <ResultDot result={row.original.result} />,
  },
  {
    header: t("Aktionen"),
    id: "actions",
    cell: ({ row }) => (
      <div
        className="flex items-center justify-end space-x-2"
        key={row.original.id}
      >
        <PutVisualAssessmentCatalogItemDialog
          catalogId={row.original.catalogId}
          item={row.original}
        />
        <DeleteVisualAssessmentCatalogItemDialog
          catalogId={row.original.catalogId}
          itemId={row.original.id}
        />
      </div>
    ),
  },
];
